<template>
  <div class="Push">
    <div class="content-info">
      <div class="">
        <p class="o-b t-i">Push Notification</p>
        <div class="b-c">
          <p class="o-b sub-t">Crear nueva Push Notification</p>
          <div class="row">
            <div class="m-top form-search-m col-md-4" >
              <div class="input-group">
                <input v-model="title" type="text" class="i-s c-f-g m-top" placeholder="Titulo" aria-label="title" aria-describedby="basic-addon1">
                <p class="error" v-if="errortTitle != ''">
                  <ul>
                    <li>{{ errortTitle }}</li>
                  </ul>
                </p>
                <input v-model="urlImagen" type="text" class=" i-s c-f-g m-top" placeholder="Url imagen" aria-label="imagen" aria-describedby="basic-addon1">
                <button v-on:click="push" class="btn-f but-g m-top m-bottom" id="basic-addon1">Crear</button>
              </div>
            </div>
            <div class="m-top col-md-8">
              <div class="input-group">
                <input v-model="descripcion" type="text" class="i-s c-f-g m-top" placeholder="Mensaje" aria-label="description" aria-describedby="basic-addon1">
                <p class="error" v-if="errortDescription != ''">
                  <ul>
                    <li>{{ errortDescription }}</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>

      <div class="b-c">
        <!-- <h3>Notificaciones push enviadas - últimos 30 días</h3> -->
        <div class="text-center m-top" v-if="notifications.length == 0">Sin resultados</div>
        <div class="text-center" v-if="notifications.length > 0">
          <table class="table table-light m-top">
            <thead>
              <tr>
                <th scope="col">Fecha</th>
                <th scope="col">Mensaje</th>
                <th scope="col">Enviados</th>
                <th scope="col">Clicks</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(notification, e) in notifications" :key="e">
                <td>{{formatDate(notification.queued_at)}}</td>
                <td style="text-align:left">{{notification.contents.en}}</td>
                <td>{{notification.successful}}</td>
                <td>{{notification.converted}} ({{conversion(notification)}})</td>
              </tr>
            </tbody>
          </table>
          <button v-if="moreAvailable" @click="loadNotificationsPage">Cargar más</button>
        </div>
      </div>

      </div>
    </div>
  </div> 
</template>

<script>
import Service from '../parse/models/Service'

export default {
  name: 'Push',
  components: {
  },
  data() {
    return {
      title: "",
      descripcion: "",
      urlImagen: "",
      errortTitle: "",
      errortDescription: "",
      notifications: [],
      moreAvailable: false,
      currentPage: 0
    }
  },
  methods: {
    push() {
      if (this.title == "") {
        this.errortTitle = 'Es necesario un titulo'

        return
      }
      if (this.descripcion == "") {
        this.errortDescription = 'Es necesario un mensaje'
        return
      }

      this.$swal({
        title: 'Espera',
        text: '¿Estás seguro que quieres enviar la push notification a todos los dispositivos?',
        type: 'warning',
        confirmButtonText: 'Si',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          this.$swal('', 'Push notification enviada', 'success')
          Service.sendPushnotification(this.title, this.descripcion, this.urlImagen)
            .then(resultado => {
              console.log(resultado)
              this.reset()
            })
            .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },
    async loadNotificationsPage() {
      let page = await this.$parse.Cloud.run('adminGetPushNotifications', { offset: this.currentPage * 50 })
      this.currentPage++

      this.moreAvailable = page.offset < page.total_count

      this.notifications.push(...page.notifications.filter(notification => notification.included_segments.includes('Active Users')))
      console.log(this.notifications)
    },
    formatDate(date) {
      return this.moment.unix(date).format('DD MMM yyyy')
    },
    conversion(notification) {
      let per = (100.0 / notification.successful) * notification.converted
      return `${per.toFixed(2)}%`
    },
    reset() {
      this.currentPage = 0
      this.notifications = []
      this.loadNotificationsPage()
    }
  },
  mounted() {
    this.loadNotificationsPage()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.calendar > .my-datepicker_calendar {
  width: 100%;
  height: 130px;
}

.a-relative {
  position: relative;
}

.a-relative button {
  position: absolute;
  left: 0;
  bottom: 0;
}

.d-i {
  display: inline-block;
  margin-right: 20px;
}

.c-t-info {
  width: 100%;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
}

.c-t-info-h-active {
  height: auto;
  max-height: 600px;
}

/* USER INFO */
.img_user {
  width: 138px;
  height: 138px;
  border-radius: 70px;
  float: left;
  margin-right: 20px;
}

.info-u {
  display: inline;
}

.info-ac button {
  display: inline;
}

table tbody tr {
  background: #f3f3f3;
}

.but-r {
  background: #e96369;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
}

.but-r:hover {
  background: rgb(231, 76, 84);
}

.but-c {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 270px;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
}

.but-c:hover {
  background: #14fc78;
}

.m-r {
  margin-right: 50px;
}

.dropdown-menu {
  width: 120px;
}

/* Container */

.content-info {
  margin-left: 310px;
  margin-right: 50px;
}

.c-i-c {
  width: 250px;
  height: 51px;
  background: #000;
  text-align: center;
  border-radius: 20px;
}

.c-i-c-t {
  width: 200px;
  height: 51px;
  background: #000;
  text-align: center;
  border-radius: 20px;
}

.t-u-c {
  padding-top: 14px;
  color: #fff;
  font-size: 16px;
}

.b-c {
  margin-right: 50px;
  margin-top: 37px;
  border: 1px solid #f6f6f6;
  -webkit-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  -moz-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  padding: 15px;
}

.sub-t {
  font-size: 18px;
  display: inline;
}

.i-f-s {
  width: 25px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

.c-f-g {
  background: #f3f3f3;
  border: none;
  padding: 10px;
  height: 40px;
  width: 100%;
  border-radius: 10px;
}

.but-g {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
}

.but-g:hover {
  background: #14fc78;
}

.but-b {
  background: #000;
  color: #fff;
  border: 0;
  width: 200px;
  height: 40px;
  border-radius: 10px;
}
.but-b:hover {
  background: rgb(27, 27, 27);
}

.f-r {
  float: right;
}

.s-o {
  background: #f3f3f3;
  border: none;
  font-family: "Open regular";
  font-size: 16px;
  padding: 5px;
  width: 200px;
}

.s-o option {
  padding: 5px;
}

.table {
  border: 1px solid #f6f6f6;
  text-align: center;
}
.btn-actions {
  background: #f6f6f6;
  border: none;
}

/*
  * Error 
  */

.error {
  color: red;
  font-size: 12px;
}

.error ul {
  padding: 0;
  list-style: none;
}
</style>
